var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DxDataGrid',_vm._b({ref:"data-grid"},'DxDataGrid',_vm.computedTableConfig,false))}
var staticRenderFns = []

export { render, staticRenderFns }